import React from "react";
import TimelineCliente from "../../componentsPrestamo/EstadoCliente/TimeLineCliente";

const Actuaciones = () => {
  return <TimelineCliente />;
};

export default Actuaciones;
